import React from 'react';
import { useIntl } from 'react-intl';

import { message } from 'antd';

import { MessageDetail } from '../utils/message';

message.config({
  maxCount: 1,
});

type Props = {
  containerClassName?: string;
};

export default function MessageHolder({ containerClassName = '' }: Props) {
  const intl = useIntl();
  const [messageApi, contextHolder] = message.useMessage();

  React.useEffect(() => {
    const handleMessage = (event: CustomEvent<MessageDetail>) => {
      const { args, type } = event.detail;
      let msg = '';

      if (typeof args === 'object' && args.message) {
        const errorCode = String(args.message);

        msg = intl.messages[`error.${errorCode}`]
          ? intl.formatMessage(
              { id: `error.${errorCode}` },
              args.extensions || {}
            )
          : errorCode;
      } else if (typeof args === 'string') {
        msg = `${intl.messages[args]}` || '';
      }

      if (msg) {
        messageApi[type](msg);
      }
    };

    document?.addEventListener('messageEvent', handleMessage as EventListener);

    return () => {
      document?.removeEventListener(
        'messageEvent',
        handleMessage as EventListener
      );
    };
  }, [intl, messageApi]);

  return <div className={containerClassName}>{contextHolder}</div>;
}
